define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/table/Copy"
], function(declare,reflection,Copy) {

	return declare(Copy, {
		/**
		 * Disable the Subtype Field
		 * @param {csi.view.Widget} view
		 */
		onCreatePopup: function(view) {
			this.inherited(arguments);

			view.setFieldDisabled(reflection.ATTR_SUBTYPE, true);
		}
	});
});